<template>
  <div class="c-material-report">
    <p-detail-filter ref="filterRef" slot="filter" @on-change="onQueryformChange" />
    <div class="table-opt-row">
      <div style="display: flex; align-items: center">
        <div class="warning-plan-type-toggle">
          <el-radio-group v-model="earlyWarningPlanType" :disabled="loading" @change="onQueryformChange">
            <el-radio-button :label="0">全部计划</el-radio-button>
            <el-radio-button :label="1">预警计划</el-radio-button>
          </el-radio-group>
          <el-badge class="waning-plan-counts-badge" :value="earlyWarningPlanCount"> </el-badge>
        </div>

        <ElDropdown @command="batchActions">
          <ElButton> 批量操作 <i class="el-icon-arrow-down el-icon--right"></i></ElButton>
          <ElDropdownMenu slot="dropdown">
            <ElDropdownItem :command="1">启用</ElDropdownItem>
            <ElDropdownItem :command="0">暂停</ElDropdownItem>
            <ElDropdownItem :command="-1">删除</ElDropdownItem>
            <!-- <DropdownItem :command="3">复制</DropdownItem> -->
            <ElDropdownItem :command="4">一键起量</ElDropdownItem>
            <ElDropdownItem :command="5">同步绑定素材</ElDropdownItem>
            <ElDropdownItem :command="6">批量项目预算修改</ElDropdownItem>
            <ElDropdownItem :command="7">批量计划预算修改</ElDropdownItem>
            <ElDropdownItem :command="8">批量出价修改</ElDropdownItem>
            <ElDropdownItem :command="9">时间段与日期</ElDropdownItem>
          </ElDropdownMenu>
        </ElDropdown>
        <ElButton type="primary" @click="batchActions(3)" v-if="hasBatchCopy" style="margin-left: 3px"> 批量复制 </ElButton>
        <ElButton icon="md-download" @click="onDownLoadAction" class="i-button" :loading="exportLoading" style="margin-left: 3px">
          数据导出
        </ElButton>

        <QueryParamsManager
          ref="queryParamsManagerRef"
          menu-id="M20638"
          :max-conditions="20"
          @select="onConditionSelect"
          @request-save="onSaveConditions"
        />
      </div>

      <div style="display: flex; align-items: center">
        <div>
          <el-switch v-model="allPlan" :disabled="loading" @change="onQueryformChange"></el-switch>
          <span>&ensp;显示近1年新建全量计划&ensp;</span>

          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              说明： 1、为了保证页面报表查询的速度，默认将【完全没有数据】的计划隐藏。<br />2、当开启开关时，近1年将完全没有数据的计划也会显示出来。<br />该功能主要用于做【历史计划的关停】需要显示全计划，避免遗漏的情况。
            </div>
            <span class="el-icon-question" style="color: #999"></span>
          </el-tooltip>

          <span>&ensp;</span>
        </div>
        <div>
          <el-switch v-model="limitConsumption" :disabled="loading" @change="onQueryformChange"></el-switch>
          <span>&ensp;过滤无消耗的计划&ensp;</span>
        </div>
        <el-button v-if="access.includes('M21268')" @click="openGameRuleDialog">游戏回调规则配置</el-button>
        <el-button v-if="access.includes('M21178')" style="margin-right: 3px; margin-left: 3px" @click="showPlanWarningSettingModal = true">
          预警计划设置
        </el-button>
        <DropdownNavigator v-if="hasCreatePlan"></DropdownNavigator>
        &ensp;

        <CustomColumnDropdownBtn
          ref="tableCustomColsRef"
          name="PtomDataCustomColumn"
          menu-id="M20638"
          :extend-id="1"
          :col-list="DEFAULT_COLS"
          :navs="NAVS"
          @change="onTableColsChange"
        ></CustomColumnDropdownBtn>
        &ensp;
        <DateRangePicker v-model="datetime" @change="onDateTimeChange" style="width: 220px" :clearable="false"></DateRangePicker>
      </div>
    </div>
    <Viewport v-model="tableHeight">
      <PDetailTable
        ref="planDataTableRef"
        :height="tableHeight"
        :loading="loading || toggleTableColLoading"
        :data="tableList"
        :columns="tableCol"
        :summary="summaries"
        @on-sort="sortTable"
        @on-detail="handleDetail"
        @on-show="handleShow"
        @show-multi-image="showMultiImage"
        @change-image="showMaterialSelectModal"
        @header-dragend="headerDragend"
        @on-refresh="getData()"
        @premium-creative-placement="showPremiumCreativeConfigModal"
      >
        <template #material-raise="{ row }">
          <template v-if="row.mediaId === MEDIAS_ENUM.TOUTIAO">
            <span class="el-icon-loading" v-if="!toutiaoMaterialRaiseLoaded"></span>
            <template v-else-if="raiseStatusMap[row.planId]">
              <el-button
                :disabled="!raiseStatusMap[row.planId].canCreate"
                type="text"
                @click="onOpenRaiseDrawer(row, TOUTIAO_RAISE_DRAWER_TYPE.CREATE)"
                >新建
              </el-button>
              <el-button
                :disabled="!raiseStatusMap[row.planId].canViewReport"
                type="text"
                @click="onOpenRaiseDrawer(row, TOUTIAO_RAISE_DRAWER_TYPE.REPORT)"
                >报告
              </el-button>

              <el-button
                :disabled="!raiseStatusMap[row.planId].canViewDetail"
                type="text"
                @click="onOpenRaiseDrawer(row, TOUTIAO_RAISE_DRAWER_TYPE.DETAIL)"
                >详情
              </el-button>

              <div v-if="raiseStatusMap[row.planId].raiseStatus === 1" style="font-size: 12px">1个起量任务进行中</div></template
            >
          </template>

          <span v-else>-</span>
        </template>
      </PDetailTable>

      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pageIndex"
        :page-size.sync="pageSizePrivate"
        :page-sizes="[20, 30, 50, 100]"
        :total="total"
        @current-change="changePageIndex"
        @size-change="onQueryformChange()"
      >
      </el-pagination>
    </Viewport>

    <!-- 选择素材列表 -->
    <pick-material v-model="pickImageModal" @on-select="materialSelectConfirm" />

    <!-- 计划详情抽屉弹窗 -->
    <DetailsDrawer v-if="showDetailsDrawer" v-model="showDetailsDrawer" :info="draInfo"> </DetailsDrawer>

    <!-- 头条起量功能 -->
    <MaterialRaiseDrawer
      :visible.sync="materialRaiseDrawerVisible"
      :plan-id="currMaterialRaisePlanId"
      :record-id="currMaterialRaiseRecordId"
      :type="currMaterialRaiseDrawerType"
      size="1120px"
      :title="raiseDrawerTitle"
      @submit="getData()"
    ></MaterialRaiseDrawer>

    <el-dialog title="素材" v-if="showMultiImageModal" :visible.sync="showMultiImageModal" width="550">
      <div class="multi-images">
        <el-popover
          v-model="image.showPop"
          v-for="image in multiImagesList"
          :key="image.id"
          placement="right-start"
          :title="image.imageName"
          trigger="manual"
        >
          <div v-if="image.showPop">
            <el-image v-if="[1].includes(image.type)" :src="image.url" style="max-width: 320px; max-height: 220px" fit="contain"></el-image>
            <video
              preload="meta"
              autoplay
              controls
              style="max-width: 420px; max-height: 320px"
              v-if="[2].includes(image.type)"
              :src="image.url"
            ></video>
          </div>

          <div class="multi-image-item" @mouseenter="image.showPop = true" @mouseleave="image.showPop = false" slot="reference">
            <img v-if="[1].includes(image.type)" :src="image.url" alt="" />
            <video preload="meta" v-if="[2].includes(image.type)" :src="image.url" alt="" />
            <div class="image-name">{{ image.imageName }}</div>
          </div>
        </el-popover>
      </div>
      <div slot="footer">
        <el-button @click="showMultiImageModal = false">取 消</el-button>
      </div>
    </el-dialog>

    <PlanWarninngSettingModal v-if="showPlanWarningSettingModal" :visible.sync="showPlanWarningSettingModal"></PlanWarninngSettingModal>

    <!-- 游戏回调规则配置弹窗 -->
    <el-dialog v-if="gameRuleDialogVisible" title="游戏回调规则配置" :visible.sync="gameRuleDialogVisible" width="600px">
      <div style="margin-bottom: 20px">
        <p style="color: #e6a23c; line-height: 1.5">
          规则说明：该功能用于配置按照【中间件纬度】归因上报的游戏，也就是按照【投放明细数据】列表字段中标记“_中间件”进行媒体的数据回调。未配置的游戏则按照原来的包体纬度进行数据回调。
        </p>
      </div>
      <el-form label-width="180px">
        <el-form-item label="中间件归因回调游戏配置">
          <el-select v-model="gameRuleForm.gameIdList" multiple filterable placeholder="请选择游戏" style="width: 100%">
            <el-option v-for="item in gameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="gameRuleDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saveGameRuleConfigLoading" @click="saveGameRuleConfig">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 广点通创意优投 -->
    <PremiumCreativeConfigModal
      :visible.sync="premiumCreativeConfigModalVisible"
      :plan-info="currentPremiumRow"
      @submit="onQueryformChange"
    />
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onActivated, nextTick, getCurrentInstance } from 'vue'
import store from '@/store'
import moment from 'moment'
import { useRoute } from 'vue-router/composables'
import DEFAULT_COLS, { NAVS, FIXED_DATA } from './data/table-cols.js'
import { MEDIAS as MEDIAS_ENUM } from '@/common/js/constants.js'
import { TOUTIAO_RAISE_DRAWER_TYPE } from './components/detail.data'

import CustomColumnDropdownBtn from '@/components/custom-column-v2/dropdown-btn.vue'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import PDetailFilter from './components/filter.vue'
import PDetailTable from './components/detail-table.vue'
import PremiumCreativeConfigModal from './components/premium-creative-config-modal.vue'
import DetailsDrawer from './components/details-drawer.vue'
import MaterialRaiseDrawer from './components/material-raise-drawer/index.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import PickMaterial from '@/components/material/material.vue'
import DropdownNavigator from '@/components/new-plan-dropdown-nav'
import PlanWarninngSettingModal from './components/plan-warning-modal/index.vue'

import { batchCheckMaterial } from '@/api/track.plan.model'
import { initPageData, GAMES } from '@/data/global-opts'

// Hooks
import { useGameRuleConfig } from './hooks/useGameRuleConfig'
import { useTableData, useTableRowToutiaoMaterialRaise, useColumns, useOperationRowStates } from './hooks/useTableData'
import { usePlanActions, usePremiumCreativeConfig } from './hooks/usePlanActions'
import { usePlanExport } from './hooks/usePlanExport'
import { useQueryParamsManager } from './hooks/useQueryParamsManager.js'

const { proxy } = getCurrentInstance()
const route = useRoute()

// Initialize global options
const PAGE_REQUIRED_OPTS = initPageData([GAMES])
const gameList = computed(PAGE_REQUIRED_OPTS.GAMES)

const now = moment().format('YYYY-MM-DD')

// Component Refs
const filterRef = ref(null)

// State
const tableHeight = ref(330)
const datetime = ref([now, now])
const planIds = ref([])
const pickImageModal = ref(false)
const editLoad = ref(false)

const access = computed(() => store.state.accessAuth)

// Computed
const editMap = computed(() => route.query.map === 'out')
const hasBatchCopy = computed(() => access.value.includes('M20986'))
const hasCreatePlan = computed(() => access.value.includes('M20987'))

const { tableCustomColsRef, tableCol, tableColumns, toggleTableColLoading, onTableColsChange, headerDragend } = useColumns()
const { queryParamsManagerRef, onSaveConditions, onConditionSelect } = useQueryParamsManager(filterRef)

const { showPlanWarningSettingModal, limitConsumption, allPlan, earlyWarningPlanType, earlyWarningPlanCount, queryEarlyWarningPlanCount } =
  useOperationRowStates()
// 头条起量功能
const {
  raiseStatusMap,
  raiseDrawerTitle,
  currMaterialRaisePlanId,
  currMaterialRaiseRecordId,
  currMaterialRaiseDrawerType,
  toutiaoMaterialRaiseLoaded,
  materialRaiseDrawerVisible,
  onOpenRaiseDrawer,
  queryRaiseStatus
} = useTableRowToutiaoMaterialRaise()

// Init Hooks
const {
  planDataTableRef,

  tableList,
  sumdata,
  loading,
  pageIndex,
  pageSizePrivate,
  total,
  sort,
  order,
  paramsCache,
  getData,
  changePageIndex,
  sortTable,
  summaries
} = useTableData({ buildQueryParams, queryEarlyWarningPlanCount, queryRaiseStatus })

// 表格行操作
const { showMultiImageModal, multiImagesList, showDetailsDrawer, draInfo, handleDetail, handleShow, showMultiImage, batchActions } =
  usePlanActions(proxy, datetime)

// 广点通创意优投
const { premiumCreativeConfigModalVisible, currentPremiumRow, showPremiumCreativeConfigModal } = usePremiumCreativeConfig()

// 表格导出
const { exportLoading, onDownLoadAction } = usePlanExport({ filterRef, buildQueryParams, tableColumns })
// 游戏回调规则配置
const { gameRuleDialogVisible, saveGameRuleConfigLoading, gameRuleForm, openGameRuleDialog, saveGameRuleConfig } = useGameRuleConfig(proxy)

const onQueryformChange = (params = {}) => {
  pageIndex.value = 1
  getData({ ...params })
}

const checkMaterial = (imageId) => {
  batchCheckMaterial({ planIds: planIds.value, imageId }).then((data) => {
    if (data) {
      proxy.$Message.success('素材绑定成功')
      onQueryformChange()
    } else {
      proxy.$Message.error('素材绑定失败')
    }
  })
}

const materialSelectConfirm = (material) => {
  const { imageId } = material
  if (imageId) {
    checkMaterial(imageId)
  }
}

const showMaterialSelectModal = (row) => {
  planIds.value = [row.planId]
  pickImageModal.value = true
}

const onDateTimeChange = () => {
  pageIndex.value = 1
  if ((!editMap.value || editLoad.value) && paramsCache.value) {
    if (filterRef.value) filterRef.value.sendEvent()
  } else if (!editMap.value) {
    onQueryformChange()
  }
}

// Build Query Params for Table Data
function buildQueryParams() {
  const filterParams = filterRef.value ? filterRef.value.buildParams() : {}
  const [beginTime, endTime] = datetime.value || ['', '']

  return {
    baseParams: {
      earlyWarningPlan: earlyWarningPlanType.value,
      limitConsumption: +limitConsumption.value,
      allPlan: +allPlan.value,
      beginTime,
      endTime,
      sort: sort.value,
      order: order.value
    },
    customParams: filterParams
  }
}
// Watchers
watch(datetime, () => {
  onDateTimeChange()
})

// Lifecycle
onMounted(() => {
  onQueryformChange()
})

onActivated(() => {
  if (editMap.value) {
    editLoad.value = false
    onConditionSelect()
  }
})
</script>
<style lang="scss" scoped>
.c-material-report {
  position: relative;

  .table-opt-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;

    .warning-plan-type-toggle {
      position: relative;
      margin-right: 3px;

      .waning-plan-counts-badge {
        position: absolute;
        z-index: 20;
        right: -3px;
      }
    }
  }

  .pager {
    text-align: right;
  }
}

::v-deep .multi-images {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  max-height: 430px;
  overflow: auto;
  > span {
    flex: 0 0 30.3333%;

    .multi-image-item {
      text-align: center;
      background: #f5f5f5;
      height: 170px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &:hover {
        background: #dadada;
      }

      video,
      img {
        max-width: 100%;
        max-height: 134px;
      }
    }
  }
}
</style>
